import PropTypes from 'prop-types';
import equals from "ramda/es/equals";
import is from "ramda/es/is";
import prop from "ramda/es/prop";
import when from "ramda/es/when";
import cx from "ramda-extension/es/cx";
import isNotNil from "ramda-extension/es/isNotNil";
import React, { useCallback, useState } from 'react';
import Collapse from 'react-css-collapse';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import TabsHorizontalMenu from '../TabsHorizontalMenu';
import { tabVariants } from '../tabVariants';
const COMPONENT_NAME = 'Tabs';
const isPanelVariant = equals(tabVariants.PANEL);
const Tabs = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, onTabClick, value, variant, asideElement, panelHeading = 'Heading', useHorizontalScroll } = props;
    const [activeTabControlled, setActiveTab] = useState(0);
    const isControlled = value !== undefined && value !== null;
    const activeTab = isControlled ? value : activeTabControlled;
    const [opened, setOpened] = useState(true);
    const handleTabLinkClick = useCallback((tabIndex)=>{
        if (!isControlled) {
            setActiveTab(tabIndex);
        }
        setOpened(equals(activeTab, tabIndex) ? !opened : true);
        onTabClick?.(tabIndex);
    }, [
        activeTab,
        isControlled,
        onTabClick,
        opened
    ]);
    const renderPanel = isPanelVariant(variant);
    return /*#__PURE__*/ React.createElement("div", {
        className: cx({
            Tabs: !renderPanel,
            Panel: renderPanel
        })
    }, renderPanel && panelHeading && /*#__PURE__*/ React.createElement("div", {
        className: "Panel-header"
    }, panelHeading), /*#__PURE__*/ React.createElement("div", {
        className: cx({
            'Tabs-list': !renderPanel,
            'Panel-header': renderPanel,
            'Tabs-list--typeAside': isNotNil(asideElement)
        })
    }, /*#__PURE__*/ React.createElement(TabsHorizontalMenu, {
        renderPanel: renderPanel,
        handleTabLinkClick: handleTabLinkClick,
        activeTab: activeTab,
        opened: opened,
        useHorizontalScroll: useHorizontalScroll
    }, children), asideElement), /*#__PURE__*/ React.createElement(Collapse, {
        isOpen: opened,
        className: "ReactCollapse"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "Tabs-main"
    }, when(is(Array), prop(activeTab))(children))));
};
Tabs.propTypes = {
    /**
	 * Optional aside element, for example Button to add a new tab
	 */ asideElement: PropTypes.element,
    /**
	 * Array of tabs
	 */ children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    /**
	 * callback fired upon tab click, contains index of clicked tab as param
	 *
	 *	@param {number} index of currently clicked tab.
	 *	@return {undefined} Nothing
	 */ onTabClick: PropTypes.func,
    /**
	 * String representation of panel heading
	 */ panelHeading: PropTypes.string,
    /**
	 * Whether to use horizontal scroll Component in case of overflow of tabs
	 */ useHorizontalScroll: PropTypes.bool,
    /**
	 * activeTab index, if not provided than component is handle it by itself
	 */ value: PropTypes.number,
    /**
	 * which variant of component to render. Defaults to BASIC
	 */ variant: PropTypes.oneOf([
        tabVariants.BASIC,
        tabVariants.PANEL
    ])
};
export default Tabs;
